<template>
  <div class="login container" :class="{height:codeshow}">
    <div class="wrapper">
      <a class="logo" href="http://www.tuling123.com/"></a>
      <div class="con-wrap">
          <div class="tit-box">
            <p class="tit" :class="{active:page==1}" @click="changePage(1)">账号登录</p>
            <p class="tit" :class="{active:page==2}" @click="changePage(2)" v-show="wxShow==1">微信登录</p>
            <p class="tit" :class="{active:page==3}" @click="changePage(3)">短信登录</p>
          </div>
         <div class="wrong" :class="{active:errorMsg!==''}">{{errorMsg}} <router-link :to="{ name: 'register'}" v-if="errorMsg=='用户名不存在，'">快速注册？</router-link></div>
         <div class="con-page" v-if="page==1">
              <input type="text" class="name" v-model="name" placeholder="用户名/手机号/注册邮箱" maxlength="50">
              <input type="password" class="pas" v-model="pas" placeholder="密码" maxlength="50" @keyup.enter="checkMsg">
              <div class="jtocode" v-show="codeshow" ref="jcode"></div>
              <div class="login-btn" @click="checkMsg">登录</div>
         </div>
         <div class="con-page" v-if="page==2">
           <div class="ewm">
             <img :src="ewmSrc" v-if="ewmSrc!==''" alt="二维码">
           </div>
         </div>
         <div class="con-page" v-if="page==3">
             <input type="text" class="cal" v-model="telphone" placeholder="手机号码" maxlength="11">
             <div class="yz">
               <input type="text" class="yz-inp" v-model="yzm" placeholder="短信验证码" maxlength="8" @keyup.enter="checkMsg">
               <button class="yz-btn" @click="sendyzm" >{{sendMsg}}</button>
             </div>
             <div class="jtocode" v-show="codeshow" ref="jcode"></div>
             <div class="login-btn" @click="checkMsg">登录</div>
         </div>
          <div class="hrefs clearfix">
            <router-link :to="{ name: 'register'}"><span @click="changeState">立即注册</span></router-link>
            <router-link :to="{ name: 'findPas'}" class="res" v-if="page==1"><span @click="forget">忘记密码</span></router-link>
          </div>
          <div class="login-way">使用第三方账号登录</div>
          <div class="elLogin">
            <a class="el1" href="#" @click="getQQ"></a>
            <a class="el2" href="#" @click="getWEI"></a>
            <a class="el3" href="#" @click="getBO"></a>
          </div>
      </div>
    </div>
    <iframe :src="iframeSrc"  frameborder="0" ref="iframe" v-show="false"></iframe>
  </div>
</template>

<script>
import mixin from '../../js/public.js';
import '../../js/geetest.js';
import $ from 'jquery';

export default{
  mixins: [mixin],
  props: {
    loginShow: {
      type: Boolean
    }
  },
  data () {
    return {
      name: '',
      pas: '',
      errorMsg: '',
      code: '',
      codeshow: false,
      id: '',
      telphone: '',
      yzm: '',
      yzmCode: '',
      page: 1,
      sendMsg: '发送短信验证码',
      wxShow: false,
      iframeSrc: '',
      ewmSrc: ''
    };
  },
  created () {
    var _this = this;
    this.id = this.uuid();
    this.wxShow = this.$route.query.wx;
    /* 判断当前页面是否是第三方登录返回，并且是那种登录 */
    this.$nextTick(function () {
      document.getElementsByTagName('title')[0].innerHTML = '登录';
      this.code = this.getUrlFn('code');
      var name = this.getUrlFn('name');
      if (this.code && name === 'qq') {
        this.loginQQ();
      } else if (this.code && name === 'wei') {
        this.loginWEI();
      } else if (this.code && name === 'bo') {
        this.loginBO();
      }
    });
  },
  methods: {
    toRegister () {
      this.$route.push({name: 'register'});
    },
    getJy () {
      if (this.$refs.jcode.innerHTML) {
        return;
      }
      var _this = this;
      $.ajax({
        url: _this.baseUrl + '/geetest/v3',
        type: 'POST',
        dataType: 'json',
        data: {id: _this.id},
        xhrFields: {
          withCredentials: true
        },
        success: function (res) {
          if (res.type === 'success') {
            window.initGeetest({
              gt: res.data.gt,
              challenge: res.data.challenge,
              new_captcha: res.data.new_captcha,
              product: 'popup',
              width: '100%',
              offline: !res.data.success
            }, _this.handlerPopup);
          }
        }
      });
    },
    uuid () {
      function S4 () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
    },
    changePage (n) {
      if (this.$refs.jcode) this.$refs.jcode.innerHTML = '';
      var _this = this;
      this.codeshow = false;
      this.errorMsg = '';
      this.page = n;
      if (n === 2) {
        this.$http.post(_this.baseUrl + '/login/p/3', {redirect_uri: location.href.split('?')[0] + '?name=wei'}, {credentials: true}).then(function (res) {
          if (res.body.type === 'success') {
            _this.iframeSrc = res.body.redirectUrl;
            _this.$refs.iframe.onload = function () {
              _this.ewmSrc = document.querySelectorAll('.lightBorder')[0].src;
            };
          } else {
            _this.errorMsg = '第三方接口出现问题，请稍后再试';
          }
        }, function () {
          _this.errorMsg = '网络错误，请稍后重试';
        });
      }
    },
    sendyzm () {
      var phonetest = /^1[0-9]{10}$/;
      var _this = this;
      if (this.sendMsg.length !== 7) {
        return;
      }
      if (!phonetest.test(this.telphone)) {
        this.errorMsg = '请输入正确的手机号码';
        return;
      }
      this.getJy();
      this.codeshow = true;
      this.errorMsg = '请进行图片验证';
    },
    toCode () {
      var _this = this;
      var i = 60;
      this.sendMsg = i + '秒';
        var nu = setInterval(function () {
          i--;
          _this.sendMsg = i + '秒';
          if (i === 0) {
            clearInterval(nu);
            _this.sendMsg = '发送短信验证码';
          }
        }, 1000);
    },
    handlerPopup (captchaObj) {
      var _this = this;
      captchaObj.appendTo('.jtocode');
      captchaObj.onReady(function () {
        setTimeout(function () {
          document.getElementsByClassName('geetest_radar_btn')[0].click();
        }, 16);
      });
      captchaObj.onSuccess(function () {
        var validate = captchaObj.getValidate();
        setTimeout(function () {
          _this.codeshow = false;
        }, 1500);
        if (_this.page === 1) {
          _this.$http.post(_this.baseUrl + '/login/p/1', {geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, username: _this.name, password: _this.pas}, {credentials: true}).then(function (res) {
            if (res.body.type === 'success') {
              window.location = _this.ReturnURl;
            } else if (res.body.code === 30000020) {
              captchaObj.reset();
              _this.errorMsg = '验证不成功';
            } else {
              captchaObj.reset();
              _this.errorMsg = '用户名或者密码错误';
            }
          }, function () {
            captchaObj.reset();
            _this.errorMsg = '网络错误，请稍后重试';
          });
        } else {
          //  发送验证码
          $.ajax({
            url: _this.baseUrl + '/login/send/5',
            type: 'POST',
            dataType: 'json',
            data: {geetest_challenge: validate.geetest_challenge, geetest_validate: validate.geetest_validate, geetest_seccode: validate.geetest_seccode, mobile: _this.telphone},
            xhrFields: {
              withCredentials: true
            },
            success: function (data) {
              if (data.type === 'success') {
                _this.errorMsg = '';
                _this.toCode();
                captchaObj.reset();
              } else {
                _this.errorMsg = '操作频繁，请稍后再试';
                captchaObj.reset();
              }
            }
          });
        }
      });
    },
    /* 登录验证用户名密码是否正确 */
    checkMsg () {
      var _this = this;
        //  账号登录
      if (this.page === 1) {
        if (this.name.trim().length < 1) {
          _this.errorMsg = '请输入用户名';
          return;
        } else if (this.pas.length < 1) {
          _this.errorMsg = '请输入密码';
          return;
        }
        _this.errorMsg = '';
        /* 登录验证是否需要极验 */
        this.$http.post(_this.baseUrl + '/login/need-verify', {username: _this.name}, {credentials: true}).then(function (res) {
          if (res.body.type === 'success') {
            /* 如果需要跳出极验 */
           if (res.body.data === true) {
             _this.getJy();
             _this.codeshow = true;
           } else {
             _this.$http.post(_this.baseUrl + '/login/p/1', {username: _this.name, password: _this.pas}, {credentials: true}).then(function (res) {
               if (res.body.type === 'success') {
                 window.location = _this.ReturnURl;
               } else if (res.body.code === 11000000) {
                 _this.errorMsg = '用户名不存在，';
               } else if (res.body.code === 11000003) {
                 _this.errorMsg = '用户名或密码错误';
               }
             }, function () {
               _this.errorMsg = '网络错误，请稍后重试';
             });
           }
          } else {
            _this.errorMsg = '网络错误，请稍后重试';
          }
        }, function () {
          _this.errorMsg = '网络错误，请稍后重试';
        });
      } else if (this.page === 2) {
        //  微信登录
      } else if (this.page === 3) {
        //  短信登录
        var phonetest = /^1[0-9]{10}$/;
        if (!phonetest.test(this.telphone)) {
          _this.errorMsg = '请输入正确的手机号码';
        } else if (this.yzm.length < 1) {
          _this.errorMsg = '请输入验证码';
        } else {
          _this.errorMsg = '';
          //  验证验证码 并登录
          _this.$http.post(_this.baseUrl + '/login/p/5', {mobile: _this.telphone, code: _this.yzm}, {credentials: true}).then(function (res) {
             if (res.body.type === 'success') {
                 window.location = _this.ReturnURl;
             } else if (res.body.code === 12100001) {
               _this.errorMsg = '验证码不正确或已过期';
             }
           }, function () {
             _this.errorMsg = '网络错误，请稍后重试';
           });
        }
      }
    },
    /* 获取qq登录跳转地址 */
    getQQ () {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/p/4', {redirect_uri: location.href.split('?')[0] + '?name=qq'}, {credentials: true}).then(function (res) {
        if (res.body.type === 'success') {
          window.location = res.body.redirectUrl;
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    },
    /* 获取微信登录跳转地址 */
    getWEI () {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/p/3', {redirect_uri: location.href.split('?')[0] + '?name=wei'}, {credentials: true}).then(function (res) {
        if (res.body.type === 'success') {
          window.location = res.body.redirectUrl;
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    },
    /* 获取微博登录跳转地址 */
    getBO () {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/p/2', {redirect_uri: location.href.split('?')[0] + '?name=bo'}, {credentials: true}).then(function (res) {
        if (res.body.type === 'success') {
          window.location = res.body.redirectUrl;
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    },
    loginQQ () {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/callback/4', {code: _this.code, redirect_uri: location.href.split('?')[0] + '?name=qq'}, {credentials: true}).then(function (res) {
        if (res.body.type === 'success') {
           window.location = _this.ReturnURl;
        } else if (res.body.code === 11000001) {
          _this.errorMsg = '第三方登录用户属性缺失，需要注册';
          window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
        } else if (res.body.code === 11100000) {
          _this.errorMsg = '第三方登录用户需要注册';
          _this.$router.push({
            name: 'third',
            query: {
              ReturnURl: _this.ReturnURl,
              name: res.body.content,
              type: 'qq'
            }
          });
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    },
    loginWEI () {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/callback/3', {code: _this.code}, {credentials: true}).then(function (res) {
        if (res.body.type === 'success') {
          window.location = _this.ReturnURl;
        } else if (res.body.code === 11000001) {
          _this.errorMsg = '第三方登录用户属性缺失，需要注册';
          window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
        } else if (res.body.code === 11100000) {
          _this.errorMsg = '第三方登录用户需要注册';
          _this.$router.push({
            name: 'third',
            query: {
              ReturnURl: _this.ReturnURl,
              name: res.body.content,
              type: 'weixin'
            }
          });
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    },
    loginBO () {
      var _this = this;
      this.$http.post(_this.baseUrl + '/login/callback/2', {code: _this.code, redirect_uri: _this.ReturnURl}, {credentials: true}).then(function (res) {
        if (res.body.type === 'success') {
          window.location = _this.ReturnURl;
        } else if (res.body.code === 11000001) {
          _this.errorMsg = '第三方登录用户属性缺失，需要注册';
          window.location = './register?type=others&ReturnURL=' + _this.ReturnURl;
        } else if (res.body.code === 11100000) {
          _this.errorMsg = '第三方登录用户需要注册';
          _this.$router.push({
            name: 'third',
            query: {
              ReturnURl: _this.ReturnURl,
              name: res.body.content,
              type: 'weibo'
            }
          });
        } else {
          _this.errorMsg = '第三方接口出现问题，请稍后再试';
        }
      }, function () {
        _this.errorMsg = '网络错误，请稍后重试';
      });
    },
    changeState () {
      this.$emit('changeState');
      if (window._czc) {
        window._czc.push(['_trackEvent', '立即注册', '点击', '立即注册按钮', '1', '立即注册按钮'])
      }
    },
    forget () {
      this.$emit('forget');
    }
  }
};
</script>

<style lang="scss" scoped="" type="text/css">
  @import '../../css/public.scss';
  .login.height{
    height: 640px;
  }
  iframe{
    width: 200px;
    height: 200px;
    position: fixed;
    right: 0;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// login.vue?09dd7d46